"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateUserState = exports.clearAddress = exports.clearLoggedUser = exports.userSlice = exports.userInitialState = void 0;
const tslib_1 = require("tslib");
const index_1 = require("./../../actions/user/updateUserLocale/index");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const getLoggedUser_1 = require("../../actions/user/getLoggedUser");
const getLoggedUserAddress_1 = require("../../actions/user/getLoggedUserAddress");
const getInsuranceBilling_1 = require("../../actions/saas/user/insurances/getInsuranceBilling");
const refreshUserMeta_1 = require("../../actions/user/refreshUserMeta");
const updateAddress_1 = require("../../actions/saas/user/addresses/updateAddress");
const createAddress_1 = require("../../actions/saas/user/addresses/createAddress");
exports.userInitialState = {
    loading: false,
    isAuthenticated: false,
    error: false,
    data: {},
    slices: {
        addresses: {
            data: [],
            loading: false,
            error: false,
        },
        address: {
            data: {},
            loading: false,
            error: false,
        },
        insurance_billing: {
            data: [],
            loading: false,
            error: false,
        },
    },
};
const combineExtraReducers = (builder) => {
    (0, getLoggedUser_1.getLoggedUserExtraReducers)(builder);
    (0, getLoggedUserAddress_1.getLoggedUserAddressExtraReducers)(builder);
    (0, getInsuranceBilling_1.getInsuranceBillingExtraReducers)(builder);
    (0, refreshUserMeta_1.refreshUserMetaUserExtraReducers)(builder);
    (0, index_1.updateUserLocaleExtraReducers)(builder);
    (0, updateAddress_1.updateUserAddressExtraReducers)(builder);
    (0, createAddress_1.createUserAddressExtraReducers)(builder);
};
exports.userSlice = toolkitRaw.createSlice({
    name: 'user',
    initialState: exports.userInitialState,
    reducers: {
        clearLoggedUser: (state) => {
            state.data = {};
            state.isAuthenticated = false;
        },
        clearAddress: (state) => {
            state.slices.address.data = {};
        },
        hydrateUserState: (state, action) => {
            state.data = { ...action.payload.data };
            state.slices = { ...action.payload.slices };
            state.isAuthenticated = action.payload.isAuthenticated;
            state.error = action.payload.error;
        },
    },
    extraReducers: (builder) => {
        return combineExtraReducers(builder);
    },
});
_a = exports.userSlice.actions, exports.clearLoggedUser = _a.clearLoggedUser, exports.clearAddress = _a.clearAddress, exports.hydrateUserState = _a.hydrateUserState;
exports.default = exports.userSlice.reducer;
//# sourceMappingURL=index.js.map